import {Injectable} from '@angular/core';
import {IncidentFilterRole, IncidentsResponse} from '@npck/af-frontend-api';
import {RouterService} from '@npck/libs/commons';
import dayjs from 'dayjs';
import {FilterEvent} from '../components/full-table/filter/filter.component';
import {initialTableEvent, TableEvent} from '../components/full-table/full-table.component';
import {IncidentsTab, IncidentTabInfo} from '../pages/incidents/incidents.component';
import {Path} from '../path';
import {AuthHolderService} from './auth-holder.service';

@Injectable({providedIn: 'root'})
export class IncidentFilterHolderService {
    private tabs: IncidentsTab[] = ['tabAllIncidents', 'tabMyIncidents', 'tabRelatedIncidents', 'tabOrganizationsIncidents'];

    private tabTableHolder = this.initialState();

    constructor(
        private authHolderService: AuthHolderService,
        private routerService: RouterService,
    ) {
        this.routerService.navigationEnd()
            .subscribe(event => {
                if (!event.url.includes(Path.INCIDENTS)) {
                    this.clear();
                }
            });
    }

    storeTableState(tab: IncidentsTab, tableEvent: TableEvent): IncidentTabInfo {
        const activeTabState = this.tabTableHolder[tab];
        const defaultFilterForTab = this.getDefaultFilterForTab(tab);
        this.tabTableHolder[tab] = {
            ...activeTabState,
            tableEvent: {
                ...tableEvent,
                filter: {
                    ...tableEvent.filter,
                    ...defaultFilterForTab,
                    sourceOrganizations: {
                        ...tableEvent.filter?.sourceOrganizations ?? {},
                        ...(defaultFilterForTab.sourceOrganizations ?? {}),
                    },
                    incidentRelatedOrganizations: {
                        ...tableEvent.filter?.incidentRelatedOrganizations ?? {},
                        ...(defaultFilterForTab.incidentRelatedOrganizations ?? {}),
                    },
                },
            },
        };
        return this.tabTableHolder[tab];
    }

    storeResponse(tab: IncidentsTab, response: IncidentsResponse): void {
        this.tabTableHolder[tab] = {...this.tabTableHolder[tab], response: response, cachedTime: dayjs()};
    }

    getState(activeTab: IncidentsTab): IncidentTabInfo {
        return this.tabTableHolder[activeTab];
    }

    clear(): void {
        this.tabTableHolder = this.initialState();
    }

    private getDefaultFilterForTab(tab: IncidentsTab): FilterEvent {
        switch (tab) {
            case 'tabAllIncidents':
                return {
                    deleted: false,
                    incidentRole: IncidentFilterRole.all,
                };
            case 'tabMyIncidents':
                return {
                    deleted: false,
                    incidentRole: IncidentFilterRole.own,
                    incidentSourceAuthors: [this.authHolderService.username],
                };
            case 'tabRelatedIncidents':
                return {
                    deleted: false,
                    incidentRole: IncidentFilterRole.related,
                    incidentRelatedOrganizations: {[this.authHolderService.organizationBin]: true},
                };
            case 'tabOrganizationsIncidents':
                return {
                    deleted: false,
                    incidentRole: IncidentFilterRole.org,
                    sourceOrganizations: {[this.authHolderService.organizationBin]: true},
                };

        }
    }

    private initialState(): Record<IncidentsTab, IncidentTabInfo> {
        return this.tabs.reduce((acc, item) => {
            if (!acc[item]) {
                acc[item] = <IncidentTabInfo>{
                    tableEvent: {
                        ...initialTableEvent,
                        filter: this.getDefaultFilterForTab(item),
                    },
                };
            }
            return acc;
        }, {} as Record<IncidentsTab, IncidentTabInfo>);
    }
}
